/* eslint-disable perfectionist/sort-objects */
export const countries = {
  AF: { name: 'Afghanistan', iso2: 'AF' },
  AX: { name: 'Åland Islands', iso2: 'AX' },
  AL: { name: 'Albania', iso2: 'AL' },
  DZ: { name: 'Algeria', iso2: 'DZ' },
  AS: { name: 'American Samoa', iso2: 'AS' },
  AD: { name: 'Andorra', iso2: 'AD' },
  AO: { name: 'Angola', iso2: 'AO' },
  AI: { name: 'Anguilla', iso2: 'AI' },
  AQ: { name: 'Antarctica', iso2: 'AQ' },
  AG: { name: 'Antigua and Barbuda', iso2: 'AG' },
  AR: { name: 'Argentina', iso2: 'AR' },
  AM: { name: 'Armenia', iso2: 'AM' },
  AW: { name: 'Aruba', iso2: 'AW' },
  AU: { name: 'Australia', iso2: 'AU' },
  AT: { name: 'Austria', iso2: 'AT' },
  AZ: { name: 'Azerbaijan', iso2: 'AZ' },
  BS: { name: 'Bahamas', iso2: 'BS' },
  BH: { name: 'Bahrain', iso2: 'BH' },
  BD: { name: 'Bangladesh', iso2: 'BD' },
  BB: { name: 'Barbados', iso2: 'BB' },
  BY: { name: 'Belarus', iso2: 'BY' },
  BE: { name: 'Belgium', iso2: 'BE' },
  BZ: { name: 'Belize', iso2: 'BZ' },
  BJ: { name: 'Benin', iso2: 'BJ' },
  BM: { name: 'Bermuda', iso2: 'BM' },
  BT: { name: 'Bhutan', iso2: 'BT' },
  BO: { name: 'Bolivia, Plurinational State of', iso2: 'BO' },
  BQ: { name: 'Bonaire, Sint Eustatius and Saba', iso2: 'BQ' },
  BA: { name: 'Bosnia and Herzegovina', iso2: 'BA' },
  BW: { name: 'Botswana', iso2: 'BW' },
  BV: { name: 'Bouvet Island', iso2: 'BV' },
  BR: { name: 'Brazil', iso2: 'BR' },
  IO: { name: 'British Indian Ocean Territory', iso2: 'IO' },
  BN: { name: 'Brunei Darussalam', iso2: 'BN' },
  BG: { name: 'Bulgaria', iso2: 'BG' },
  BF: { name: 'Burkina Faso', iso2: 'BF' },
  BI: { name: 'Burundi', iso2: 'BI' },
  KH: { name: 'Cambodia', iso2: 'KH' },
  CM: { name: 'Cameroon', iso2: 'CM' },
  CA: { name: 'Canada', iso2: 'CA' },
  IC: { name: 'Canary Islands', iso2: 'IC' },
  CV: { name: 'Cape Verde', iso2: 'CV' },
  KY: { name: 'Cayman Islands', iso2: 'KY' },
  CF: { name: 'Central African Republic', iso2: 'CF' },
  TD: { name: 'Chad', iso2: 'TD' },
  CL: { name: 'Chile', iso2: 'CL' },
  CN: { name: 'China', iso2: 'CN' },
  CX: { name: 'Christmas Island', iso2: 'CX' },
  CC: { name: 'Cocos (Keeling) Islands', iso2: 'CC' },
  CO: { name: 'Colombia', iso2: 'CO' },
  KM: { name: 'Comoros', iso2: 'KM' },
  CG: { name: 'Congo', iso2: 'CG' },
  CD: { name: 'Congo, the Democratic Republic of the', iso2: 'CD' },
  CK: { name: 'Cook Islands', iso2: 'CK' },
  CR: { name: 'Costa Rica', iso2: 'CR' },
  CI: { name: "Côte d'Ivoire", iso2: 'CI' },
  HR: { name: 'Croatia', iso2: 'HR' },
  CU: { name: 'Cuba', iso2: 'CU' },
  CW: { name: 'Curaçao', iso2: 'CW' },
  CY: { name: 'Cyprus', iso2: 'CY' },
  CZ: { name: 'Czech Republic', iso2: 'CZ' },
  DK: { name: 'Denmark', iso2: 'DK' },
  DJ: { name: 'Djibouti', iso2: 'DJ' },
  DM: { name: 'Dominica', iso2: 'DM' },
  DO: { name: 'Dominican Republic', iso2: 'DO' },
  EC: { name: 'Ecuador', iso2: 'EC' },
  EG: { name: 'Egypt', iso2: 'EG' },
  SV: { name: 'El Salvador', iso2: 'SV' },
  GQ: { name: 'Equatorial Guinea', iso2: 'GQ' },
  ER: { name: 'Eritrea', iso2: 'ER' },
  EE: { name: 'Estonia', iso2: 'EE' },
  ET: { name: 'Ethiopia', iso2: 'ET' },
  FK: { name: 'Falkland Islands (Malvinas)', iso2: 'FK' },
  FO: { name: 'Faroe Islands', iso2: 'FO' },
  FJ: { name: 'Fiji', iso2: 'FJ' },
  FI: { name: 'Finland', iso2: 'FI' },
  FR: { name: 'France', iso2: 'FR' },
  GF: { name: 'French Guiana', iso2: 'GF' },
  PF: { name: 'French Polynesia', iso2: 'PF' },
  TF: { name: 'French Southern Territories', iso2: 'TF' },
  GA: { name: 'Gabon', iso2: 'GA' },
  GM: { name: 'Gambia', iso2: 'GM' },
  GE: { name: 'Georgia', iso2: 'GE' },
  DE: { name: 'Germany', iso2: 'DE' },
  GH: { name: 'Ghana', iso2: 'GH' },
  GI: { name: 'Gibraltar', iso2: 'GI' },
  GR: { name: 'Greece', iso2: 'GR' },
  GL: { name: 'Greenland', iso2: 'GL' },
  GD: { name: 'Grenada', iso2: 'GD' },
  GP: { name: 'Guadeloupe', iso2: 'GP' },
  GU: { name: 'Guam', iso2: 'GU' },
  GT: { name: 'Guatemala', iso2: 'GT' },
  GG: { name: 'Guernsey', iso2: 'GG' },
  GN: { name: 'Guinea', iso2: 'GN' },
  GW: { name: 'Guinea-Bissau', iso2: 'GW' },
  GY: { name: 'Guyana', iso2: 'GY' },
  HT: { name: 'Haiti', iso2: 'HT' },
  HM: { name: 'Heard Island and McDonald Islands', iso2: 'HM' },
  VA: { name: 'Holy See (Vatican City State)', iso2: 'VA' },
  HN: { name: 'Honduras', iso2: 'HN' },
  HK: { name: 'Hong Kong', iso2: 'HK' },
  HU: { name: 'Hungary', iso2: 'HU' },
  IS: { name: 'Iceland', iso2: 'IS' },
  IN: { name: 'India', iso2: 'IN' },
  ID: { name: 'Indonesia', iso2: 'ID' },
  IR: { name: 'Iran, Islamic Republic of', iso2: 'IR' },
  IQ: { name: 'Iraq', iso2: 'IQ' },
  IE: { name: 'Ireland', iso2: 'IE' },
  IM: { name: 'Isle of Man', iso2: 'IM' },
  IL: { name: 'Israel', iso2: 'IL' },
  IT: { name: 'Italy', iso2: 'IT' },
  JM: { name: 'Jamaica', iso2: 'JM' },
  JP: { name: 'Japan', iso2: 'JP' },
  JE: { name: 'Jersey', iso2: 'JE' },
  JO: { name: 'Jordan', iso2: 'JO' },
  KZ: { name: 'Kazakhstan', iso2: 'KZ' },
  KE: { name: 'Kenya', iso2: 'KE' },
  KI: { name: 'Kiribati', iso2: 'KI' },
  KP: { name: "Korea, Democratic People's Republic of", iso2: 'KP' },
  KR: { name: 'Korea, Republic of', iso2: 'KR' },
  KW: { name: 'Kuwait', iso2: 'KW' },
  KG: { name: 'Kyrgyzstan', iso2: 'KG' },
  LA: { name: "Lao People's Democratic Republic", iso2: 'LA' },
  LV: { name: 'Latvia', iso2: 'LV' },
  LB: { name: 'Lebanon', iso2: 'LB' },
  LS: { name: 'Lesotho', iso2: 'LS' },
  LR: { name: 'Liberia', iso2: 'LR' },
  LY: { name: 'Libya', iso2: 'LY' },
  LI: { name: 'Liechtenstein', iso2: 'LI' },
  LT: { name: 'Lithuania', iso2: 'LT' },
  LU: { name: 'Luxembourg', iso2: 'LU' },
  MO: { name: 'Macao', iso2: 'MO' },
  MK: { name: 'North Macedonia, Republic of', iso2: 'MK' },
  MG: { name: 'Madagascar', iso2: 'MG' },
  MW: { name: 'Malawi', iso2: 'MW' },
  MY: { name: 'Malaysia', iso2: 'MY' },
  MV: { name: 'Maldives', iso2: 'MV' },
  ML: { name: 'Mali', iso2: 'ML' },
  MT: { name: 'Malta', iso2: 'MT' },
  MH: { name: 'Marshall Islands', iso2: 'MH' },
  MQ: { name: 'Martinique', iso2: 'MQ' },
  MR: { name: 'Mauritania', iso2: 'MR' },
  MU: { name: 'Mauritius', iso2: 'MU' },
  YT: { name: 'Mayotte', iso2: 'YT' },
  MX: { name: 'Mexico', iso2: 'MX' },
  FM: { name: 'Micronesia, Federated States of', iso2: 'FM' },
  MD: { name: 'Moldova, Republic of', iso2: 'MD' },
  MC: { name: 'Monaco', iso2: 'MC' },
  MN: { name: 'Mongolia', iso2: 'MN' },
  ME: { name: 'Montenegro', iso2: 'ME' },
  MS: { name: 'Montserrat', iso2: 'MS' },
  MA: { name: 'Morocco', iso2: 'MA' },
  MZ: { name: 'Mozambique', iso2: 'MZ' },
  MM: { name: 'Myanmar', iso2: 'MM' },
  NA: { name: 'Namibia', iso2: 'NA' },
  NR: { name: 'Nauru', iso2: 'NR' },
  NP: { name: 'Nepal', iso2: 'NP' },
  NL: { name: 'Netherlands', iso2: 'NL' },
  NC: { name: 'New Caledonia', iso2: 'NC' },
  NZ: { name: 'New Zealand', iso2: 'NZ' },
  NI: { name: 'Nicaragua', iso2: 'NI' },
  NE: { name: 'Niger', iso2: 'NE' },
  NG: { name: 'Nigeria', iso2: 'NG' },
  NU: { name: 'Niue', iso2: 'NU' },
  NF: { name: 'Norfolk Island', iso2: 'NF' },
  MP: { name: 'Northern Mariana Islands', iso2: 'MP' },
  NO: { name: 'Norway', iso2: 'NO' },
  OM: { name: 'Oman', iso2: 'OM' },
  PK: { name: 'Pakistan', iso2: 'PK' },
  PW: { name: 'Palau', iso2: 'PW' },
  PS: { name: 'Palestine, State of', iso2: 'PS' },
  PA: { name: 'Panama', iso2: 'PA' },
  PG: { name: 'Papua New Guinea', iso2: 'PG' },
  PY: { name: 'Paraguay', iso2: 'PY' },
  PE: { name: 'Peru', iso2: 'PE' },
  PH: { name: 'Philippines', iso2: 'PH' },
  PN: { name: 'Pitcairn', iso2: 'PN' },
  PL: { name: 'Poland', iso2: 'PL' },
  PT: { name: 'Portugal', iso2: 'PT' },
  PR: { name: 'Puerto Rico', iso2: 'PR' },
  QA: { name: 'Qatar', iso2: 'QA' },
  RE: { name: 'Réunion', iso2: 'RE' },
  RO: { name: 'Romania', iso2: 'RO' },
  RU: { name: 'Russian Federation', iso2: 'RU' },
  RW: { name: 'Rwanda', iso2: 'RW' },
  BL: { name: 'Saint Barthélemy', iso2: 'BL' },
  SH: { name: 'Saint Helena, Ascension and Tristan da Cunha', iso2: 'SH' },
  KN: { name: 'Saint Kitts and Nevis', iso2: 'KN' },
  LC: { name: 'Saint Lucia', iso2: 'LC' },
  MF: { name: 'Saint Martin (French part)', iso2: 'MF' },
  PM: { name: 'Saint Pierre and Miquelon', iso2: 'PM' },
  VC: { name: 'Saint Vincent and the Grenadines', iso2: 'VC' },
  WS: { name: 'Samoa', iso2: 'WS' },
  SM: { name: 'San Marino', iso2: 'SM' },
  ST: { name: 'Sao Tome and Principe', iso2: 'ST' },
  SA: { name: 'Saudi Arabia', iso2: 'SA' },
  SN: { name: 'Senegal', iso2: 'SN' },
  RS: { name: 'Serbia', iso2: 'RS' },
  SC: { name: 'Seychelles', iso2: 'SC' },
  SL: { name: 'Sierra Leone', iso2: 'SL' },
  SG: { name: 'Singapore', iso2: 'SG' },
  SX: { name: 'Sint Maarten (Dutch part)', iso2: 'SX' },
  SK: { name: 'Slovakia', iso2: 'SK' },
  SI: { name: 'Slovenia', iso2: 'SI' },
  SB: { name: 'Solomon Islands', iso2: 'SB' },
  SO: { name: 'Somalia', iso2: 'SO' },
  ZA: { name: 'South Africa', iso2: 'ZA' },
  GS: { name: 'South Georgia and the South Sandwich Islands', iso2: 'GS' },
  SS: { name: 'South Sudan', iso2: 'SS' },
  ES: { name: 'Spain', iso2: 'ES' },
  LK: { name: 'Sri Lanka', iso2: 'LK' },
  SD: { name: 'Sudan', iso2: 'SD' },
  SR: { name: 'Suriname', iso2: 'SR' },
  SJ: { name: 'Svalbard and Jan Mayen', iso2: 'SJ' },
  SZ: { name: 'Swaziland', iso2: 'SZ' },
  SE: { name: 'Sweden', iso2: 'SE' },
  CH: { name: 'Switzerland', iso2: 'CH' },
  SY: { name: 'Syrian Arab Republic', iso2: 'SY' },
  TW: { name: 'Taiwan', iso2: 'TW' },
  TJ: { name: 'Tajikistan', iso2: 'TJ' },
  TZ: { name: 'Tanzania, United Republic of', iso2: 'TZ' },
  TH: { name: 'Thailand', iso2: 'TH' },
  TL: { name: 'Timor-Leste', iso2: 'TL' },
  TG: { name: 'Togo', iso2: 'TG' },
  TK: { name: 'Tokelau', iso2: 'TK' },
  TO: { name: 'Tonga', iso2: 'TO' },
  TT: { name: 'Trinidad and Tobago', iso2: 'TT' },
  TN: { name: 'Tunisia', iso2: 'TN' },
  TR: { name: 'Turkey', iso2: 'TR' },
  TM: { name: 'Turkmenistan', iso2: 'TM' },
  TC: { name: 'Turks and Caicos Islands', iso2: 'TC' },
  TV: { name: 'Tuvalu', iso2: 'TV' },
  UG: { name: 'Uganda', iso2: 'UG' },
  UA: { name: 'Ukraine', iso2: 'UA' },
  AE: { name: 'United Arab Emirates', iso2: 'AE' },
  GB: { name: 'United Kingdom', iso2: 'GB' },
  US: { name: 'United States', iso2: 'US' },
  UM: { name: 'United States Minor Outlying Islands', iso2: 'UM' },
  UY: { name: 'Uruguay', iso2: 'UY' },
  UZ: { name: 'Uzbekistan', iso2: 'UZ' },
  VU: { name: 'Vanuatu', iso2: 'VU' },
  VE: { name: 'Venezuela, Bolivarian Republic of', iso2: 'VE' },
  VN: { name: 'Viet Nam', iso2: 'VN' },
  VG: { name: 'Virgin Islands, British', iso2: 'VG' },
  VI: { name: 'Virgin Islands, U.S.', iso2: 'VI' },
  WF: { name: 'Wallis and Futuna', iso2: 'WF' },
  EH: { name: 'Western Sahara', iso2: 'EH' },
  XK: { name: 'Kosovo', iso2: 'XK' },
  YE: { name: 'Yemen', iso2: 'YE' },
  ZM: { name: 'Zambia', iso2: 'ZM' },
  ZW: { name: 'Zimbabwe', iso2: 'ZW' },
} as const;
/* eslint-enable perfectionist/sort-objects */

type CountriesMap = typeof countries;
export type CountryIso2 = keyof CountriesMap;

export type Country = {
  iso2: CountryIso2;
  iso3?: string;
  name: string;
};

// see: http://www.upu.int/uploads/tx_sbdownloader/2019.12_ADU_Knowledge_Centre_General_Addressing.pdf
export const countriesWithoutZip = [
  countries.AE,
  countries.AG,
  countries.AI, // single postal code
  countries.AO,
  countries.AS, // single postal code
  countries.AW,
  countries.BF,
  countries.BI,
  countries.BJ,
  countries.BO,
  countries.BQ,
  countries.BS,
  countries.BW,
  countries.BZ,
  countries.CC, // single postal code
  countries.CD,
  countries.CF,
  countries.CG,
  countries.CI,
  countries.CK,
  countries.CM,
  countries.CW,
  countries.CX, // single postal code
  countries.DJ,
  countries.DM,
  countries.ER,
  countries.FJ,
  countries.FK,
  countries.FO, // single postal code
  countries.GD,
  countries.GH,
  countries.GI, // single postal code
  countries.GM,
  countries.GQ,
  countries.GS, // single postal code
  countries.GY,
  countries.HK,
  countries.HM,
  countries.IE,
  countries.IO, // single postal code
  countries.JM,
  countries.KI,
  countries.KM,
  countries.KN,
  countries.KP,
  countries.LC,
  countries.LR,
  countries.LY,
  countries.ML,
  countries.MO,
  countries.MR,
  countries.NF, // single postal code
  countries.NR, // single postal code
  countries.NU, // single postal code
  countries.PA,
  countries.PN, // single postal code
  countries.PW, // single postal code
  countries.QA,
  countries.RW,
  countries.SB,
  countries.SC,
  countries.SH, // single postal code
  countries.SL,
  countries.SO,
  countries.SR,
  countries.SS,
  countries.ST,
  countries.SX,
  countries.SY,
  countries.TC, // single postal code
  countries.TD,
  countries.TF,
  countries.TG,
  countries.TK,
  countries.TL,
  countries.TO,
  countries.TV,
  countries.TZ,
  countries.UG,
  countries.UM,
  countries.VA, // single postal code
  countries.VU,
  countries.YE,
  countries.ZM,
  countries.ZW,
];

// Source: https://pe.usps.com/text/imm/immc2_022.htm
export const uspsTrackingCountryIso2Whitelist: Partial<keyof typeof countries>[] = [
  'AU', // Australia
  'AT', // Austria
  'BE', // Belgium
  'BR', // Brazil
  'CA', // Canada
  'CL', // Chile
  'HR', // Croatia
  'CY', // Cyprus
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GI', // Gibraltar
  'GR', // Greece
  'HK', // Hong Kong
  'HU', // Hungary
  'IS', // Iceland
  'IL', // Israel
  'ID', // Indonesia
  'IT', // Italy
  'JP', // Japan
  'LV', // Latvia
  'LB', // Lebanon
  'LT', // Lithuania
  'LU', // Luxembourg
  'MY', // Malaysia
  'MT', // Malta
  'MX', // Mexico
  'NL', // Netherlands
  'NZ', // New Zealand
  'NO', // Norway
  'PL', // Poland
  'PT', // Portugal
  'RU', // Russia
  'SA', // Saudi Arabia
  'RS', // Serbia, Republic of
  'SG', // Singapore
  'SK', // Slovak Republic (Slovakia)
  'SI', // Slovenia
  'ES', // Spain
  'CH', // Switzerland
  'TH', // Thailand
  'TR', // Turkey
  'VN', // Vietnam
];

// The United Kingdom's ISO2 name is GB but USPS abbreviates them as UK, see https://about.usps.com/postal-bulletin/2018/pb22509/html/updt_008.htm
export const uspsTrackingCountryAdditionalWhitelist = ['UK'];

export const EuCountries: Partial<CountryIso2>[] = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
];

export const countryHasMasterAccount = (country: Country) => {
  const masterAccountCountries = ['US', 'AU', 'DE', 'CA'];
  return masterAccountCountries.indexOf(country.iso2) !== -1;
};
